import { useQuery, useQueryClient } from "@tanstack/react-query";
import { UserService } from "src/services";
import { QueryParamsMapper } from "src/mappers";
import { queryKeys } from "src/constants";
import { DateTimeRange, UsersFiltersState, UserPaginationOptions } from "src/types";

const useUsers = (
  userService: UserService,
  dateTimeRange?: DateTimeRange,
  filters?: UsersFiltersState,
  paginationOptions?: UserPaginationOptions
) => {
  const queryClient = useQueryClient();

  const queryParams = QueryParamsMapper.getUsersQueryParams(dateTimeRange, filters, paginationOptions);

  const {
    data: paginatedUsers,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: queryKeys.paginatedUsers(queryParams),
    queryFn: () => userService.getUsers(queryParams)
  });

  const refreshUsers = () => {
    queryClient.removeQueries({
      queryKey: queryKeys.paginatedUsers(),
      exact: false
    });
  };

  return { paginatedUsers, fetchError, isLoading, refreshUsers };
};

export { useUsers };
